export default __webpack_public_path__ + "static/media/report_navicon.89a5158f.svg";